module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('page-title', {
    attrs: {
      "title": _vm.$t(_vm.preset.type).label
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-left"
    },
    slot: "header-left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.preset.from.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i-arrow icon-arrow-right"
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.preset.to.logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': !_vm.preset.active
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false)
      }
    }
  }, [_vm._v("\n          Inativo\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': _vm.preset.active
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(true)
      }
    }
  }, [_vm._v("\n          Ativo\n        ")])])]), _vm._v(" "), _c('panel', [_c('loader', {
    attrs: {
      "loading": _vm.loadingAddItem
    }
  }), _vm._v(" "), _c(_vm.typeComponentAddItem, {
    ref: "typeComponentAddItem",
    tag: "component",
    attrs: {
      "preset": _vm.preset
    },
    on: {
      "loading": _vm.onChangeAddItem,
      "addItemEnable": _vm.addItemEnable
    }
  }, [_c('div', {
    staticClass: "l-col-2@md vertical-center"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    attrs: {
      "disabled": !_vm.enabledAdd,
      "data-label": ("Adicionar configuração de " + (_vm.$t(_vm.preset.type).label) + ".")
    },
    on: {
      "click": _vm.addPresetItem
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  })])])])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Predefinições cadastradas"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingItem
    }
  }), _vm._v(" "), _vm._l((_vm.preset.items), function(item) {
    return _c(_vm.typeComponentItem, {
      key: item,
      ref: "typeComponentItem",
      refInFor: true,
      tag: "component",
      attrs: {
        "preset": _vm.preset,
        "item": item
      },
      on: {
        "loading": _vm.onChangeItem
      }
    }, [_c('button', {
      staticClass: "hint hint--left btn btn--danger",
      attrs: {
        "data-label": ("Remover configuração de " + (_vm.$t(_vm.preset.type).label) + ".")
      },
      on: {
        "click": function($event) {
          return _vm.showConfirm(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-bin"
    })])])
  }), _vm._v(" "), (!_vm.preset.items.length) ? _c('div', {
    staticClass: "u-textCenter"
  }, [_vm._v("\n        Nenhuma predefinição cadastrada.\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('remove-dialog', {
    on: {
      "option": _vm.removePresetItem
    },
    model: {
      value: (_vm.removeItemFlag),
      callback: function($$v) {
        _vm.removeItemFlag = $$v
      },
      expression: "removeItemFlag"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d9a0ea2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Preset/Edit.vue
// module id = 3326
// module chunks = 0